import { useTranslation } from "react-i18next";

export default function Translate(props) {
  const { t } = useTranslation();

  return t(props.text);
}
